export default {
  ukBenefitUpfront1: {
    id: 'uk_benefit_upfront_1',
    defaultMessage: 'One-time payment.',
  },
  ukBenefitMonthly1: {
    id: 'uk_benefit_monthly_1',
    defaultMessage: 'Monthly plan. Cancel anytime after 12 months.',
  },
  ukBenefit2: {
    id: 'uk_benefit_2',
    defaultMessage:
      'Every crack on your screen, every fault, every knock it takes — we step in.',
  },
  ukBenefit3: {
    id: 'uk_benefit_3',
    defaultMessage: 'Unlimited repair requests.',
  },
  ukBenefit4: {
    id: 'uk_benefit_4',
    defaultMessage: 'Fast 3-day mail-in repairs',
  },
  ukBenefit5: {
    id: 'uk_benefit_5',
    defaultMessage: 'No questions asked. Decision in 24h.',
  },
}
